import { PostShareResponse, Share, ShareState, ShareType } from "../../../proto/api_pb";
import { getShareUrl } from "../../../services/shareService";

export const createAndCopyShareUrl = async (
  objectId: string,
  userId: string,
  accessToken: string,
  shareType: number,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string,
  password?: string
): Promise<string | undefined> => {
  console.log("=== createAndCopyShareUrl DEBUG ===");
  console.log("objectId (project IDs):", objectId);
  console.log("userId:", userId);
  console.log("shareType:", shareType);
  console.log("title:", title);

  const share = new Share();

  share.setObjectId(objectId);
  share.setOwnerId(userId);
  share.setExpiryTimestamp(expiryTimeStamp);
  share.setMaxViews(maxViews);
  share.setAllowDownload(allowDownload);
  share.setUnlimitedViews(isAllowUnlimitedViews);
  share.setTrackTitle(title);
  share.setShareState(ShareState.SHARE_STATE_ACTIVE);
  if (enterpriseId) {
    share.setEnterpriseId(enterpriseId);
  }
  if (password) {
    share.setPassword(password);
  }

  if (shareType === ShareType.SHARE_TYPE_TRACK) {
    share.setShareType(ShareType.SHARE_TYPE_TRACK);
  } else if (shareType === ShareType.SHARE_TYPE_FOLDER) {
    share.setShareType(ShareType.SHARE_TYPE_FOLDER);
  } else if (shareType === ShareType.SHARE_TYPE_PROJECT) {
    share.setShareType(ShareType.SHARE_TYPE_PROJECT);
  } else if (shareType === ShareType.SHARE_TYPE_PROJECTS_COLLECTION) {
    share.setShareType(ShareType.SHARE_TYPE_PROJECTS_COLLECTION);
  } else {
    console.error("Invalid share type");
    return;
  }

  const response = await getShareUrl(accessToken, userId, share, enterpriseId);

  console.log("=== API Response DEBUG ===");
  console.log("Raw response:", response);

  if (response instanceof PostShareResponse) {
    const responseShare = response.getShare();
    console.log("Response share objectId:", responseShare?.getObjectId());
    console.log("Response share ID:", responseShare?.getId());
    console.log("Response share enterpriseId:", responseShare?.getEnterpriseId());
    const id = response.getShare()?.getId();
    let shareLink = `${process.env.REACT_APP_URL}/share/${id}`;

    if (shareType === ShareType.SHARE_TYPE_FOLDER) {
      shareLink = `${process.env.REACT_APP_URL}/share/${title}/${id}`;
    } else if (shareType === ShareType.SHARE_TYPE_PROJECT) {
      shareLink = `${process.env.REACT_APP_URL}/share/project/${title}/${id}`;
    } else if (shareType === ShareType.SHARE_TYPE_PROJECTS_COLLECTION) {
      shareLink = `${process.env.REACT_APP_URL}/share/projects/${id}`;
    }

    try {
      await navigator.clipboard.writeText(shareLink);
      console.log("Url successfully copied to clipboard");
    } catch (err) {
      console.error("Unable to copy Url to clipboard", err);
    }

    return shareLink;
  }
};